import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'com-pagination',
  templateUrl: './com-pagination.component.html',
  styleUrls: ['./com-pagination.component.scss']
})
export class ComPaginationComponent {
  @Input() current: number = 1;
  @Input() totalPages: number = 1;
  @Input() range: number = 2; // 表示するページ番号の範囲（現在のページを中心に前後表示するページ数）
  @Input() sideCount: number = 1; // 最初と最後の表示ページ数
  @Output() pageChange = new EventEmitter<number>();

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  jumpTo(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.current) {
      this.pageChange.emit(page);
    }
  }

  jumpToMiddle(direction: 'prev' | 'next'): void {
    let targetPage = 1;

    if (direction === 'prev') {
      // 1ページ目から、現在表示されている最小ページ（current - range）の間の中間地点
      const start = this.sideCount;
      const end = this.current - this.range;
      targetPage = Math.floor((start + end) / 2);
    } else if (direction === 'next') {
      // 現在表示されている最大ページ（current + range）から、最終ページの間の中間地点
      const start = this.current + this.range;
      const end = this.totalPages + 1 - this.sideCount;
      targetPage = Math.floor((start + end) / 2);
    }
    this.jumpTo(targetPage);
  }
}